import { Fragment, useEffect, useState } from "react"
import { Button, Input, message, Modal, Form, Space, Col, Row, DatePicker, Select, Upload } from "antd"
import { useForm } from "antd/lib/form/Form"
import { UploadOutlined } from '@ant-design/icons'
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import { apiPrefix } from "../../../js/config"
import _ from 'lodash'

const { Option } = Select

interface Prop {
    payID?: string,
    visible: boolean
    onCancel: () => void
}

interface payDetail {
    pay_time: string,
    pay_code: string,
    pay_item: number,
    pay_way: number,
    pay_amount: number,
    pay_prov_pic_list: string,
    review_status: number,
    review_refuse_reason: string
}

interface reciveRow {
    prov_pic_list: undefined | string[], // 凭证图片集合，上传图片接口返回的图片路径
}

const upLoadProps = {
    name: 'files',
    data: { fileType: 1, bucketType: 4 },
    action: apiPrefix + '/global/upload_pic',
}

export default function (prop: Prop) {

    const [data, setData] = useState<payDetail>()

    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    const [reciveMoneyData, setReciveMoneyData] = useState<reciveRow[]>([{
        prov_pic_list: []
    }])

    const uploadChange = (info: any) => {
        let reciveD: any = _.cloneDeep(reciveMoneyData)

        if (info.file.status === 'done') {
            message.success(`${info.file.name} 上传成功`)
            reciveD[0].prov_pic_list.push(info.file.response.data[0])

            setReciveMoneyData(reciveD)

        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);

        } else if (info.file.status === 'removed') {
            let i = reciveD[0].prov_pic_list.findIndex((el: string) => el === info.file.response.data[0])
            reciveD[0].prov_pic_list.splice(i, 1)

            setReciveMoneyData(reciveD)
        }
    }

    useEffect(() => {
        if (prop.payID) {
            baseAxiosNoInfo('/keeper/check_in/pay_amount/detail', {
                params: {
                    pay_id: prop.payID
                }
            }).then((res: any) => {
                res && setData(res)
                setVisible(true)
            })
        }
    }, [prop.payID])

    const onFinish = () => {
        baseAxiosComplete.post('/keeper/check_in/pay_amount/update', {
            pay_id: prop.payID,
            pay_date: form.getFieldValue('pay_time') ? form.getFieldValue('pay_time').format('YYYY-MM-DD') : '',
            pay_code: form.getFieldValue("pay_code"),
            pay_item: form.getFieldValue('pay_item'),
            pay_way: form.getFieldValue('pay_way'),
            pay_amount: form.getFieldValue("pay_amount"),
            pay_prov_pic_list: reciveMoneyData[0].prov_pic_list
        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
            }
        })
    }

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 修改收款 */}
        <Modal title="收款编辑" width={500} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <Row>
                <Col span={9}>
                    <div>
                        <Space>
                            <p>收款日期：</p>
                            <p>{data?.pay_time}</p>
                        </Space>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={9}>
                    <Space>
                        <p>收款项目：</p>
                        <p>
                            {
                                data?.pay_item == 3 ? '一对一陪护' :
                                    data?.pay_item == 4 ? '合同尾款' :
                                        data?.pay_item == 5 ? '医院陪护' :
                                            data?.pay_item == 6 ? '月嫂到家' :
                                                data?.pay_item == 7 ? '续住' :
                                                    data?.pay_item == 8 ? '其他' : ''
                            }
                        </p>
                    </Space>
                </Col>
                <Col span={9}>
                    <Space>    
                        <p>收款方式：</p>
                        <p>
                            {
                                data?.pay_way == 1 ? '现金' :
                                    data?.pay_way == 2 ? '支付宝' :
                                        data?.pay_way == 3 ? '微信' :
                                            data?.pay_way == 4 ? '银联卡' :
                                                data?.pay_way == 8 ? '抵扣券' : ''
                            }
                        </p>
                    </Space>
                </Col>
            </Row>

            <Row>
                <Col span={9}>
                    <Space>
                        <p>收款单号：</p>
                        <p>{data?.pay_code}</p>
                    </Space>
                </Col>
                <Col span={9}>
                    <Space>
                        <p>收款金额：</p>
                        <p>{data?.pay_amount}</p>
                    </Space>
                </Col>
            </Row>

            <Row>
                <Col span={12}>
                    <div>
                        <Space>
                            <p>不通过原因：</p>
                            <p>{data?.review_refuse_reason}</p>
                        </Space>
                    </div>
                </Col>
            </Row>

            <div style={{ marginTop: 8 }}>
                <Form form={form}>
                    <Form.Item label="收款日期" name="pay_time">
                        <DatePicker showToday />
                    </Form.Item>
                    <Form.Item label="收款单号" name="pay_code">
                        <Input style={{ width: 180 }} />
                    </Form.Item>
                    <Form.Item label="收款项目" name="pay_item">
                        <Select style={{ width: 180 }}>
                            <Option key={3} value={3}>一对一陪护</Option>
                            <Option key={4} value={4}>合同尾款</Option>
                            <Option key={5} value={5}>医院陪护</Option>
                            <Option key={6} value={6}>月嫂到家</Option>
                            <Option key={7} value={7}>续住</Option>
                            <Option key={8} value={8}>其他</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="收款方式" name="pay_way">
                        <Select style={{ width: 180 }}>
                            <Option key={1} value={1}>现金</Option>
                            <Option key={2} value={2}>支付宝</Option>
                            <Option key={3} value={3}>微信</Option>
                            <Option key={4} value={4}>银联卡</Option>
                            <Option key={8} value={8}>抵扣券</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="收款金额" name="pay_amount">
                        <Input style={{ width: 180 }} />
                    </Form.Item>

                    <Form.Item label="收款凭证" name="check_out_drive_time">
                        <Upload {...upLoadProps} onChange={(info: any) => {
                            uploadChange(info)
                        }}>
                            <Button icon={<UploadOutlined />} size="small" ></Button>
                        </Upload>
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    </Fragment>
}